/* DSCC Commercial Landing v1 */
(() => {
    "use strict";

    /* =====================================================
       CONFIGURATION
       ===================================================== */

    /*
      REPLACE THESE TWO NUMBERS:

      1. PETTY_CASH_VARIANT_ID
         The Shopify variant ID for the $5 Petty Cash product.

      2. PETTY_CASH_SELLING_PLAN_ID
         The Shopify selling plan ID for the monthly subscription.

      They must be numbers, not the full Shopify admin URL.
    */

    const PETTY_CASH_VARIANT_ID = Number.parseInt(
      document.getElementById("PettyVariantId")?.value || "",
      10
    );
    const PETTY_CASH_SELLING_PLAN_ID = Number.parseInt(
      document.getElementById("PettySellingPlan")?.value || "",
      10
    );

    /*
      Change this only if the actual Shopify product handle differs.
    */
    const THIS_IS_OUR_YEAR_URL = "/products/this-is-our-year";

    const WRONG_ANSWER_DELAY_MS = 5000;
    const SERIOUS_ROTATION_MS = 20000;
    const PETTY_ROTATION_MS = 10000;

    /* =====================================================
       BENEFIT ARRAYS
       ===================================================== */

    const seriousBenefits = [
      "Early access to new coffee releases.",
      "Occasional free coffee samples.",
      "Early access to limited-edition merchandise.",
      "Behind-the-scenes updates on new campaigns.",
      "Help fund our next billboard campaign.",
      "Support an independent small business."
    ];

    const pettyBenefits = [
      "The joy of seeing “DALLAS SUCKS COFFEE” on your credit card statement every month.",
      "Help make Cowboys fans feel uncomfortable in their own town.",
      "The next time you see a Cowboys fan crash out, take pride in knowing it was probably your fault.",
      "Help Eagles fans quietly occupy Dallas one billboard at a time.",
      "Turn petty into public art.",
      "Help fund the pettiest coffee company on the planet.",
      "Know that someone in Dallas is probably rolling their eyes because of you.",
      "Every time a Cowboys fan gets angry at one of our billboards, remember that you helped pay for it.",
      "Give “Dallas Sucks” a microphone loud enough to cross state lines."
    ];

    /* =====================================================
       BENEFIT ROTATOR
       ===================================================== */

    const seriousElement = document.getElementById(
      "dscc-serious-benefit"
    );

    const pettyElement = document.getElementById(
      "dscc-petty-benefit"
    );

    let seriousIndex = 0;
    let pettyIndex = 0;

    function replaceBenefit(element, newText) {
      if (!element) {
        return;
      }

      element.classList.add("dscc-changing");

      window.setTimeout(() => {
        element.textContent = newText;
        element.classList.remove("dscc-changing");
      }, 280);
    }

    function rotateSeriousBenefit() {
      seriousIndex = (seriousIndex + 1) % seriousBenefits.length;

      replaceBenefit(
        seriousElement,
        seriousBenefits[seriousIndex]
      );
    }

    function rotatePettyBenefit() {
      pettyIndex = (pettyIndex + 1) % pettyBenefits.length;

      replaceBenefit(
        pettyElement,
        pettyBenefits[pettyIndex]
      );
    }

    const reducedMotionQuery = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    );

    if (!reducedMotionQuery.matches) {
      window.setInterval(
        rotateSeriousBenefit,
        SERIOUS_ROTATION_MS
      );

      window.setInterval(
        rotatePettyBenefit,
        PETTY_ROTATION_MS
      );
    }

    /* =====================================================
       JOIN PETTY CASH
       ADD SUBSCRIPTION TO CART AND REDIRECT TO CHECKOUT
       ===================================================== */

    const joinButton = document.getElementById(
      "dscc-join-petty-cash"
    );

    const checkoutError = document.getElementById(
      "dscc-checkout-error"
    );

    async function addPettyCashToCart() {
      if (!joinButton) {
        return;
      }

      checkoutError?.classList.remove("dscc-visible");

      const originalButtonHtml = joinButton.innerHTML;

      joinButton.disabled = true;
      joinButton.innerHTML =
        'Adding Petty Cash...' +
        '<span class="dscc-cta-subtext">Preparing checkout</span>';

      try {
        if (
          !Number.isInteger(PETTY_CASH_VARIANT_ID) ||
          PETTY_CASH_VARIANT_ID <= 0 ||
          !Number.isInteger(PETTY_CASH_SELLING_PLAN_ID) ||
          PETTY_CASH_SELLING_PLAN_ID <= 0
        ) {
          throw new Error(
            "Petty Cash variant ID or selling plan ID has not been configured."
          );
        }

        const response = await fetch(
          window.Shopify.routes.root + "cart/add.js",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify({
              items: [
                {
                  id: PETTY_CASH_VARIANT_ID,
                  quantity: 1,
                  selling_plan: PETTY_CASH_SELLING_PLAN_ID
                }
              ]
            })
          }
        );

        if (!response.ok) {
          const errorData = await response.json().catch(() => null);

          throw new Error(
            errorData?.description ||
            errorData?.message ||
            "Shopify rejected the cart request."
          );
        }

        window.location.assign("/checkout");
      } catch (error) {
        console.error("Petty Cash cart error:", error);

        joinButton.disabled = false;
        joinButton.innerHTML = originalButtonHtml;

        if (checkoutError) {
          checkoutError.textContent =
            "We couldn't add the membership to your cart. " +
            "Please try again.";

          checkoutError.classList.add("dscc-visible");
        }
      }
    }

    joinButton?.addEventListener(
      "click",
      addPettyCashToCart
    );

    /* =====================================================
       WRONG ANSWER MODAL
       ===================================================== */

    const wrongAnswerButton = document.getElementById(
      "dscc-this-is-our-year"
    );

    const cowboysModal = document.getElementById(
      "dscc-cowboys-modal"
    );

    let redirectStarted = false;

    function showCowboysModal() {
      if (!cowboysModal || redirectStarted) {
        return;
      }

      redirectStarted = true;
      cowboysModal.hidden = false;
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";

      window.setTimeout(() => {
        window.location.assign(THIS_IS_OUR_YEAR_URL);
      }, WRONG_ANSWER_DELAY_MS);
    }

    wrongAnswerButton?.addEventListener(
      "click",
      showCowboysModal
    );
  })();
